import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRotate360Left: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRotate360Left"><Path d="M13.5 13.5L10.5 16.5L13.5 19.5" stroke="currentColor"/><Path d="M6.75 15.7642C3.61154 14.8132 1.5 13.0358 1.5 11C1.5 7.96243 6.20101 5.5 12 5.5C17.799 5.5 22.5 7.96243 22.5 11C22.5 14.0376 17.799 16.5 12 16.5H10.9756" stroke="currentColor"/></CentralIconBase>;
});

export default IconRotate360Left;
